import { ROOT_SERVER_URL } from '../config';
import { request } from '../utils';

export function getFlags() {
  return request(`${ROOT_SERVER_URL}/api/flags`);
}

export function getFlag(flag) {
  return request(`${ROOT_SERVER_URL}/api/flags/${flag}`);
}

export function updateFlag(flag, changes) {
  return request(`${ROOT_SERVER_URL}/api/flags/${flag}`, {
    data: changes,
    method: 'PUT',
  });
}
